import { VideoItem } from 'services/data-manager/types';

import { AudioTrackEncodeType } from 'components/Player/types.ts';
import { StandardUavProps } from 'components/Ribbon/types';

import { StreamTypes } from './actions.types';

export type Subtitle = 'n/a' | 'hu' | 'en';
export type Audio = 'hu' | 'en';
export type SubtitlesFontSize = '75' | '100' | '200' | '300';

type SubtitlesByProfileId = {
    [key: string]: Subtitle;
};

type AudiosByProfileId = {
    [key: string]: Audio;
};

type SubtitlesFontSizeByProfileId = {
    [key: string]: SubtitlesFontSize;
};

export type PlayerState = {
    visible: boolean;
    videoItem?: VideoItem;
    playbackType?: StreamTypes;
    fullscreenBlocked: boolean;
    subtitles: SubtitlesByProfileId;
    audio: AudiosByProfileId;
    subtitlesFontSize: SubtitlesFontSizeByProfileId;
    shouldUpdateId: boolean;
    fullscreen: boolean;
    openedDetailPage?: string;
    spotlightVideoVisible: boolean;
    muted: boolean;
    volume: number;
    prevPositiveVolume: number;
} & StandardUavProps;

export enum PlayerTrackEncodeType {
    BITMAP,
    EIA_608,
    EIA_708,
    ID3,
    SMPTE,
    SRT,
    WEBVTT,
    UNKNOWN = 1000,
}

type PlayerChannelCountType = 1 | 2 | 6 | 12 | 'A000';

export type PlayerTrack = {
    id: string | undefined;
    title: string;
    language: string;
    encodeType: PlayerTrackEncodeType | AudioTrackEncodeType;
    characteristics?: string[];
    channelCount?: PlayerChannelCountType;
};

export type PlayerTracks = {
    textTracks: PlayerTrack[];
    audioTracks: PlayerTrack[];
};
